__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "@bnimove/shell";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@bnimove/design-system", "1.0.0", () => (Promise.all([__webpack_require__.e(452), __webpack_require__.e(169)]).then(() => (() => (__webpack_require__(5452))))));
			register("@bnimove/shared", "1.0.0", () => (Promise.all([__webpack_require__.e(91), __webpack_require__.e(156)]).then(() => (() => (__webpack_require__(91))))));
			register("@capacitor/core", "7.6.8", () => (__webpack_require__.e(546).then(() => (() => (__webpack_require__(6546))))));
			register("@capacitor/filesystem", "7.1.8", () => (Promise.all([__webpack_require__.e(867), __webpack_require__.e(761)]).then(() => (() => (__webpack_require__(5142))))));
			register("@emotion/react", "11.14.0", () => (__webpack_require__.e(839).then(() => (() => (__webpack_require__(2839))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(479), __webpack_require__.e(531)]).then(() => (() => (__webpack_require__(1479))))));
			register("@reduxjs/toolkit", "2.12.0", () => (__webpack_require__.e(879).then(() => (() => (__webpack_require__(9879))))));
			register("react-dom", "19.2.4", () => (() => (__webpack_require__(961))), 1);
			register("react-redux", "9.3.0", () => (__webpack_require__.e(965).then(() => (() => (__webpack_require__(7965))))));
			register("react-router-dom", "6.30.6", () => (Promise.all([__webpack_require__.e(648), __webpack_require__.e(405)]).then(() => (() => (__webpack_require__(2648))))));
			register("react/jsx-runtime", "19.2.4", () => (() => (__webpack_require__(5259))), 1);
			register("react/jsx-runtime", "19.2.4", () => (() => (__webpack_require__(892))), 1);
			register("react/jsx-runtime", "19.2.4", () => (() => (__webpack_require__(4848))), 1);
			register("react", "19.2.4", () => (() => (__webpack_require__(5184))), 1);
			register("react", "19.2.4", () => (() => (__webpack_require__(6540))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};